import { Grid } from "@mui/system";
import { Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import WithoutFtdAndNetRevTable, {
  WITHOUT_FTD_AND_NETREV_COLUMNS,
} from "./WithoutFtdAndNetRevTable";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const WithoutFtdAndNetRev = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const withoutFtdAndNetRevBrandData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.withoutFtdAndNetRevBrandData,
  );

  const withoutFtdAndNetRevBrandMetadata = useSelector(
    (state: any) =>
      state.bizDevelopmentAnomalies.withoutFtdAndNetRevBrandMetadata,
  );

  const isFetchedForBrandData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForBrandData,
  );

  //-- Extract unique brand names for the search filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (withoutFtdAndNetRevBrandData || []).forEach((r: any) => {
      if (typeof r?.brand_display_name === "string")
        set.add(r.brand_display_name.trim());
    });
    return Array.from(set);
  }, [withoutFtdAndNetRevBrandData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return withoutFtdAndNetRevBrandData;
    return (withoutFtdAndNetRevBrandData || []).filter((row: any) =>
      String(row.brand_display_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [withoutFtdAndNetRevBrandData, choosenBrand]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Brands without FTD & NetRev in the Last 60 Days
          </Typography>
        </Grid>
        <Grid size={4}>
          <BrandSearchBar
            dataTrackerForSearch="881"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="879"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                WITHOUT_FTD_AND_NETREV_COLUMNS,
                "brands-without-ftd-netrev.csv",
              )
            }
            disabled={
              (withoutFtdAndNetRevBrandData?.length ?? 0) === 0 ||
              !isFetchedForBrandData
            }
          />
        </Grid>
      </Grid>
      <WithoutFtdAndNetRevTable
        metadata={withoutFtdAndNetRevBrandMetadata}
        rows={filteredData}
      />
    </>
  );
};

export default WithoutFtdAndNetRev;
